// extracted by mini-css-extract-plugin
export default {"page":"SmsInfo_page__+G3MG","content":"SmsInfo_content__3+ASM"};